import { BaseService } from "./BaseService";
import type {
  BookingPaymentSummary,
  GuestWalletTopUpResponse,
  TopUpGuestWalletPayload,
} from "@/types/booking-payments";

class BookingPaymentsService extends BaseService {
  private basePath = "/payments/bookings";

  constructor() {
    super();
  }

  async getBookingPaymentSummary(
    bookingId: string,
  ): Promise<BookingPaymentSummary> {
    return this.get<BookingPaymentSummary>(
      `${this.basePath}/${bookingId}/summary`,
    );
  }

  async topUpGuestWallet(
    bookingId: string,
    payload: TopUpGuestWalletPayload,
  ): Promise<GuestWalletTopUpResponse> {
    return this.post<GuestWalletTopUpResponse>(
      `${this.basePath}/${bookingId}/wallet/top-ups`,
      payload,
    );
  }
}

export const bookingPaymentsService = new BookingPaymentsService();
